import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import Carousel from "react-spring-3d-carousel";

import Image from './Image';

function CarouselWrapper(props){
  let slides = props.selections.map((selection, i) => {
    return {
      key: selection.key,
      content: <Image key={"carousel" + i} selection={selection} />,
      onClick: () => props.setSlideIndex(i)
    }
  });


  return (
      <div className="CarouselWrapper">
        <div className="navWrapper">
          <div className="nav left" onClick={() => props.setSlideIndex((props.slideIndex - 1) % props.selections.length)}/>
          <div className="nav right" onClick={() => props.setSlideIndex((props.slideIndex + 1) % props.selections.length)}/>
        </div>
        <Carousel
          slides={slides}
          offsetRadius={2}
          showNavigation={false}
          goToSlide={props.slideIndex}
          />
          <div className="dots">
            {slides.map((slide, i) => <div className={"dot " + (props.slideIndex === i ? 'active' : '')} key={'dot'+i} onClick={slide.onClick} />)}
          </div>
      </div>
  );
}

export default observer(CarouselWrapper);
